import axios from 'axios';

window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

import './echo';

import * as Sentry from '@sentry/react';

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: 'https://8846bbb1f64a0e912d7834a2d324f94e@o4508627123830784.ingest.us.sentry.io/4508629046067200',
    release: import.meta.env.VITE_SENTRY_RELEASE,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [
      /^https:\/\/hivewise\.dev/,
      /^https:\/\/teamwashi\.dev/,
      /^https:\/\/washi\.com/,
      /^https:\/\/app\.washi\.com/,
    ],
    replaysOnErrorSampleRate: 1.0,
  });
}
